import './style.less';

export default function($log) {
  'ngInject';

  this.$onChanges = activate;

  const vm = this;

  vm.clear = () => {
    vm.searchModel = undefined;
    vm.ngModel = undefined;

    vm.ngCallback({ selected: vm.ngModel });
  };

  vm.translation = {
    selectAll: 'Select All',
    selectNone: 'Deselect All',
    reset: 'Reset',
    search: 'Search',
    nothingSelected: 'All'
  };

  function activate() {
    $log.debug('Option Select component activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/optionSelectSearch/controller.js